// extracted by mini-css-extract-plugin
export default {"container":"VideoControls_container__3DFAt","mobile":"VideoControls_mobile__A90ZF","containerInner":"VideoControls_containerInner__lTplV","link":"VideoControls_link__eEIba"};